export default "__VITE_ASSET__D1$Jdh$Y__"